<script lang="ts">
  import { m } from "$lib/paraglide/messages";
  import Button from "./MatomoButton.svelte";
  import DOMPurify from "isomorphic-dompurify";
</script>

<aside class="grid max-sm:grid-rows-[1fr_auto] sm:grid-cols-[1fr_auto] items-center gap-xl p-2xl justify-center">
  <p class="text-large-regular text-text-primary">
    {@html DOMPurify.sanitize(m.origin_linux_message(), { RETURN_TRUSTED_TYPE: true })}
  </p>
  <Button
    href="https://laptop-updates.brave.com/latest/origin"
    eventAction="[Origin] Download button click"
    eventName="[Origin] Download button"
    eventValue="linux"
  >
    {m.origin_download_text()}
  </Button>
</aside>

<style>
  aside {
    background: linear-gradient(180deg, var(--leo-color-pink-10) 0%, var(--leo-color-purple-10) 100%);
  }
</style>
